<script setup lang="ts">
import { computed } from "vue";

import type { SightlineStickyCell } from "@/backend/natsstubs/sightline/models";
import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import { useStickyTypeStore } from "@/store/stickyType";

import SightlineTruncatedText from "./SightlineTruncatedText.vue";

const props = defineProps<{ cell: SightlineStickyCell }>();

const stickyTypeStore = useStickyTypeStore();
const stickyType = computed(() => stickyTypeStore.findStickyType(props.cell.typeId));
</script>

<template>
  <TypeDot size="medium" :color="stickyType.color" />
  <SightlineTruncatedText :text="cell.label" />
</template>
